import {
  Box,
  Button,
  Flex,
  FormControl,
  FormErrorMessage,
  FormLabel,
  Image,
  Input,
  InputGroup,
  InputRightElement,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';

import { useAuth } from '../hooks/useAuth';
import { AuthService } from '../services/auth.service';

export function Login() {
  const { login } = useAuth();

  const navigate = useNavigate();
  const {
    handleSubmit,
    register,
    formState: { errors, isSubmitting },
  } = useForm({});
  const [loginError, setLoginError] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const onSubmit = useCallback(
    async (creds) => {
      setLoginError(null);
      try {
        await AuthService.login(creds);
        login(creds);
        navigate('/search', { replace: true });
      } catch (e) {
        const errorObj = { status: e.response.status };
        if (errorObj.status === 401) {
          errorObj.message = 'Usuario o contraseña no válidos';
        } else {
          errorObj.message = 'Error inesperado, intenta de nuevo';
        }
        setLoginError(errorObj);
      }
    },
    [login, navigate]
  );

  return (
    <Flex alignItems='center' direction='column' gap='4' h='100%' pt='24'>
      <VStack spacing='8'>
        <Image alt='Casa Ley' boxSize='150px' objectFit='scale-down' src='/logo_casa_ley.jpg' />
        <Text fontSize='4xl'>Inicia sesión</Text>
      </VStack>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <FormControl isInvalid={Object.keys(errors).length || loginError}>
          <Stack spacing={6}>
            <Box>
              <FormLabel htmlFor='username'>Usuario</FormLabel>
              <Input
                autoComplete='username'
                id='username'
                isInvalid={errors.username}
                name='username'
                {...register('username', {
                  required: 'Este campo es requerido',
                })}
              />
              <FormErrorMessage fontWeight='500'>
                {errors.username && errors.username.message}
              </FormErrorMessage>
            </Box>
            <Box>
              <FormLabel htmlFor='password'>Contraseña</FormLabel>

              <InputGroup size='md'>
                <Input
                  autoComplete='current-password'
                  id='password'
                  isInvalid={errors.password}
                  name='password'
                  type={showPassword ? 'text' : 'password'}
                  {...register('password', {
                    required: 'Este campo es requerido',
                  })}
                  pr='4.5rem'
                />
                <InputRightElement pr='1' width='4.5rem'>
                  <Button
                    h='1.75rem'
                    size='sm'
                    variant='outline'
                    onClick={() => setShowPassword((show) => !show)}
                  >
                    {showPassword ? 'Ocultar' : 'Mostrar'}
                  </Button>
                </InputRightElement>
              </InputGroup>
              <FormErrorMessage fontWeight='500'>
                {errors.password && errors.password.message}
              </FormErrorMessage>
            </Box>
            <Button isLoading={isSubmitting} type='submit' w='100%'>
              Iniciar sesión
            </Button>
            <FormErrorMessage fontWeight='500'>{loginError && loginError.message}</FormErrorMessage>
          </Stack>
        </FormControl>
      </Form>
    </Flex>
  );
}

const Form = styled.form`
  height: 100%;
`;
